// PayTR panelinden yapılıp işlem dökümünden yakalanan iadelerde kullanıcı yoktur.
export const refundActorLabel = (refund) =>
    refund.source === "PROVIDER_PANEL" ? "PayTR paneli" : refund.createdByName || "-";
